$ = require('jquery')
PositionCalculator = require('position-calculator')
require('angular')
require("angular-bootstrap")
require('../hdcp/hdcp-module')
require('../../../core/translation/translation-module')
require('../../../../../ngapp/external-scripts/angular-confirm/angular-confirm.min')
require('../../../../../ngapp/external-scripts/angular-inf-scroll/angular-infinitescroll')
require('../../../../../ngapp/external-scripts/lazy-load-image/lazy-img-load')


MatchValidateDirective = require('./match-validate-directive')
DateInputDirective = require('./date-input-directive')
SubmitDirective = require('./submit-directive')
CustomValidateDirective = require("./custom-validate-directive")
PlayerHdcpDirective = require("./player-hdcp-directive")
FormDecorator = require("./form-decorator-service")
CustomSelectDirective = require("./custom-select-directive")
CustomEmailValidatorDirective = require("./custom-email-validator-directive")
DisableAllDirective = require('./disable-all-directive')
SubmittingButtonDirective = require('./submitting-button-directive')
TrustedTextFilter = require('./trusted-text-filter')
FormDialogService = require('./form-file-dialog-service')
FormFileReaderService = require('./form-file-reader-service')
FormCopyService = require('./form-copy-service')
FormatStringFilter = require('./format-string-filter')

modules = [
  'gnp-translation'
  'gnp-hdcp'
  'ui.bootstrap'
  'cp.ngConfirm'
  'infinite-scroll'
  'angularLazyImg'
]
angular.module 'gnp-form', modules
  .config FormDecorator
  .directive 'gnpMatchValidate', MatchValidateDirective
  .directive 'gnpDateInput', DateInputDirective
  .directive 'gnpSubmit', SubmitDirective
  .directive 'gnpPlayerHdcp', PlayerHdcpDirective
  .directive 'gnpCustomValidate', CustomValidateDirective
  .directive 'gnpCustomSelect', CustomSelectDirective
  .directive 'gnpCustomEmailValidator', CustomEmailValidatorDirective
  .directive 'gnpDisableAll', DisableAllDirective
  .directive 'gnpSubmittingButton', SubmittingButtonDirective
  .factory   'formDialogService', FormDialogService
  .factory   'formFileReaderService', FormFileReaderService
  .factory   'formCopyService', FormCopyService
  .filter 'trustedText', TrustedTextFilter
  .filter 'formatString', FormatStringFilter
  .run ->
    $(document).on "shown.bs.dropdown.position-calculator", (event, data) ->
      $item = $(".dropdown-menu", event.target)
      return unless $item.data("placement")
      target = data.relatedTarget

      # reset position
      $item.css
        top: 0
        left: 0

      # calculate new position
      calculator = new PositionCalculator
        item: $item
        target: target
        itemAt: "top left"
        itemOffset:
          y: 3
          x: 0
          mirror: true

        targetAt: "bottom left"
        flip: "both"

      posResult = calculator.calculate()

      # set new position
      $item.css
        top: posResult.moveBy.y + "px"
        left: posResult.moveBy.x + "px"

      return



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/form-module.coffee